import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Select extends PureComponent {
  renderData(data) {
    return data.map((item, idx) => (
      <option key={ idx } value={ item.value } { ...item }>
        { item.label }
      </option>
    ));
  }

  render() {
    const { className, children, data, ...others } = this.props;
    const cls = classNames({
      "weui-select": true
    }, className);

    return (
      <select className={ cls } { ...others }>
        { data?.length > 0 ? this.renderData(data) : children }
      </select>
    );
  }
}
